@if (jobs.invitations().length === 0) {
  <app-platform-jobs-empty-state
    [icon]="icons.envelope"
    [title]="'jobboard.platform.jobs.invitations.empty-title' | transloco"
    [text]="'jobboard.platform.jobs.invitations.empty-text' | transloco"
    [ctaLabel]="'jobboard.platform.jobs.invitations.empty-cta' | transloco"
    [ctaIcon]="icons.user"
    [ctaLink]="['/profile']"
  />
} @else {
  <div class="table-wrapper">
    <p-table
      [value]="jobs.invitations()"
      dataKey="id"
      [rowTrackBy]="trackById"
      sortField="receivedAt"
      [sortOrder]="-1"
      [scrollable]="true"
      [scrollHeight]="'flex'"
    >
      <ng-template #header>
        <tr>
          <th pSortableColumn="jobTitle">
            {{ 'jobboard.platform.jobs.table.job' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th pSortableColumn="companyName">
            {{ 'jobboard.platform.jobs.table.company' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th class="d-none d-md-table-cell" pSortableColumn="location">
            {{ 'jobboard.platform.jobs.table.location' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th class="d-none d-lg-table-cell table-date-column" pSortableColumn="receivedAt">
            {{ 'jobboard.platform.jobs.table.received-at' | transloco }}
            <fa-icon class="sort" [icon]="icons.sort"></fa-icon>
            <fa-icon class="sortUp" [icon]="icons.sortUp"></fa-icon>
            <fa-icon class="sortDown" [icon]="icons.sortDown"></fa-icon>
          </th>
          <th class="actions">{{ 'jobboard.platform.jobs.table.actions' | transloco }}</th>
        </tr>
      </ng-template>
      <ng-template #body let-invitation>
        <tr>
          <td>
            <div class="cell-job">
              @if (invitation.jobUrl; as jobUrl) {
                <a
                  [href]="jobUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                >{{ invitation.jobTitle }}</a>
              } @else {
                <span>{{ invitation.jobTitle }}</span>
              }
              @if (invitation.closed) {
                <ct-lib-tag [variant]="TagVariant.GRAY">
                  {{ 'jobboard.platform.jobs.invitations.closed-tag' | transloco }}
                </ct-lib-tag>
              }
            </div>
          </td>
          <td>
            <div class="cell-company">
              @if (jobs.jobboardCompanyUrl(invitation.companyId); as companyUrl) {
                <a
                  [href]="companyUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  [attr.aria-label]="'jobboard.platform.jobs.open-company' | transloco"
                >
                  <app-platform-company-logo
                    [companyName]="invitation.companyName"
                    [companyId]="invitation.companyId"
                    [small]="true"
                  />
                  <span>{{ invitation.companyName }}</span>
                </a>
              } @else {
                <app-platform-company-logo
                  [companyName]="invitation.companyName"
                  [companyId]="invitation.companyId"
                  [small]="true"
                />
                <span>{{ invitation.companyName }}</span>
              }
            </div>
          </td>
          <td class="d-none d-md-table-cell">{{ invitation.location }}</td>
          <td class="d-none d-lg-table-cell table-date-column">
            {{ invitation.receivedAt | date: 'dd.MM.yyyy' }}
          </td>
          <td class="actions">
            @if (!invitation.closed) {
              <app-platform-job-apply-menu
                [context]="jobs.applyContextFromInvitation(invitation)"
              />
              <fa-icon
                [icon]="icons.decline"
                size="lg"
                [tooltip]="'jobboard.platform.jobs.invitations.decline' | transloco"
                [attr.aria-label]="'jobboard.platform.jobs.invitations.decline' | transloco"
                (click)="decline(invitation)"
              ></fa-icon>
            }
            @if (invitation.closed) {
              <fa-icon
                [icon]="icons.trash"
                size="lg"
                class="red"
                [tooltip]="'jobboard.platform.jobs.invitations.remove-aria' | transloco"
                [attr.aria-label]="'jobboard.platform.jobs.invitations.remove-aria' | transloco"
                (click)="remove(invitation)"
              ></fa-icon>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
}
